import React from 'react';
import { useEffect, useState } from 'react';
import CautionIcon from '../../_styles/images/Caution.svg';
import SelectCardBox from './SelectCardBox';
import AddIcon from '../../_styles/images/AddIcon.png';
import Close from '../../_styles/images/close-icon-green.svg';
import TickIcon from '../../_styles/images/tick-badge.svg';
import TickIconContainer from '../../shared/components/tick-icon-container/TickIconContainer';

export default function MakeOriginalRetailAsBackup(props) {

  const [selected, updateSelected] = useState(null);
  const [disabled, updateDisabled] = useState(true);
  const [addPaymentSelected, updateAddPaymentSelected] = useState(false);

  function onSelect(card) {
    if (card && card.referenceId) {
      updateSelected(card);
      updateAddPaymentSelected(false);
      updateDisabled(false);
    } else if(card && card.addNewCard){
      updateSelected(null);
      updateAddPaymentSelected(true);
      updateDisabled(false);
    } else {
      updateDisabled(true);
      updateSelected(null);
      updateAddPaymentSelected(false);
    }
  }

  // function selectAddPayment() {
  //   updateAddPaymentSelected(true);
  // }

  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        const changesPopup = document.getElementById('make-original-retail-as-backup');
        if (changesPopup) {
          props.close();
        }
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  }, []);

  function onSave() {
    if(selected){
      props.confirm(selected);
    }else{
      props.AddPayment();
    }
  }

  return (
    <div className='card-operations-container make-original-retail-container' ref={props.reference} role='dialog' aria-describedby='heading' aria-modal='true'>
      <div className='retail-confirm-header'>
        <img className='close' src={Close} onClick={props.close} role='button' alt='close icon' />
      </div>
      <div className='make-original-retail-as-backup' id='make-original-retail-as-backup'>
        <div className='caution-icon'>
          <img src={CautionIcon} alt='warning image'></img>
        </div>
        <div className='heading' id='heading'>{props.heading}</div>
        <div className='foot-notes'>{props.text}</div>
        <div className='card-list-container original-retail'>
          {
            props && props.cards && props.cards.map((card) => 
              <SelectCardBox retailConfirm={true} key={card.partialAccountNumber + card.cardBrand} ref={props.reference} card={card} selected={selected && selected.referenceId} onClick={() => onSelect(card)} />
            )
          }
          <div tabIndex={0} className={`add-button-div ${addPaymentSelected ? ' selected' : ''}`} onClick={() => onSelect({addNewCard: true})} >
              {
                addPaymentSelected && <TickIconContainer src={TickIcon} />
              }
          <div className='add-button'>  <img src={AddIcon} aria-hidden='true' />Add New Card</div>
          </div>
          {/* <button className='add-button' onClick={props.AddPayment}>  <img src={AddIcon} aria-hidden='true' />Add New Card</button> */}
        </div>
        <div className='buttons'>
          <button className='confirmation-delete-button' disabled={disabled} onClick={() => onSave()}>{props.confirmButtonText}</button>
        </div>
      </div>
    </div>
  );
}
